import React from 'react';
import { ReactComponent as Icon } from '../../../assets/icon-error.svg';
import createSvgIcon from '../../../shared/utils/create-svg-icon';

export const ErrorIcon = createSvgIcon(<Icon />, 'ErrorIcon');
